import * as React from 'react'
import { SVGProps } from 'react'
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M8 13c-1.86 0-3.41 1.28-3.86 3H2v2h2.14c.45 1.72 2 3 3.86 3 1.86 0 3.41-1.28 3.86-3H22v-2H11.86c-.45-1.72-2-3-3.86-3m11.86-7c-.45-1.72-2-3-3.86-3-1.86 0-3.41 1.28-3.86 3H2v2h10.14c.45 1.72 2 3 3.86 3 1.86 0 3.41-1.28 3.86-3H22V6h-2.14" />
  </svg>
)
export default SvgFilter
